import React, {useEffect, useRef, useState} from 'react';
import { Template } from "../../../components/template/template.jsx";
import "../../../css/style-report.css";
import "../../../css/input-date-time.css";
import ReportUtils from "../../../utils/report-utils.js";
import {useGlobalKey} from "../../../hooks/use-global-key.js";
import {Card} from "../../../components/card/card.jsx";
import {subWeeks} from "date-fns";
import NotAppliedContent from "../../../components/reports/report-menu/not-applied-content.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import NoDataContent from "../../../components/reports/report-menu/no-data-content.jsx";
import Menu from "../../../components/reports/report-menu/menu.jsx";
import Filters from "./components/filters.jsx";
import AutoDatetime from "../../../components/reports/auto-datetime/auto-datetime.jsx";
import passageLabelsXrayService from "../../../services/reports/passage-labels-xray-service.js";
import Content from "./components/content.jsx";

const initialFilters = () => {
  const refDay = new Date();
  return {
    dtStart: subWeeks(refDay, 1),
    dtEnd: refDay
  }
};

const filterLabels = {
  dtStart: "Data/hora inicial",
  dtEnd: "Data/hora final",
};

const PassageLabelsXRay = () => {
  const [loading, setLoading] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [filters, setFilters] = useState(initialFilters);

  const [fixedTop, setFixedTop] = useState(null);
  const buttonRef = useRef(null);

  const title = 'Raio X de marcadores';
  const [headerSelected, setHeaderSelected] = useState(-1);

  useEffect(() => {
    if (!reportData) return;

    ReportUtils.appendFilters(
      ReportUtils.filters({
        ...filters,
        dtStart: filters.dtStart ? ReportUtils.formatDateTime(filters.dtStart) : "",
        dtEnd: filters.dtEnd ? ReportUtils.formatDateTime(filters.dtEnd) : "",
      }, filterLabels)
    );

  }, [reportData]);

  const apply = async () => {
    ReportUtils.applyLoad({
      setLoading,
      clearContent: () => {
        setReportData(null)
      }
    });

    try {
      const periodValidation = ReportUtils.periodValidate(filters.dtStart, filters.dtEnd);

      if (!periodValidation.ok) {
        ReportUtils.alertErrorMessage(periodValidation.message);
        setLoading(false);
        return;
      }

      const formattedFilters = {
        dtStart: filters.dtStart ? ReportUtils.formatDateTime(filters.dtStart) : null,
        dtEnd: filters.dtEnd ? ReportUtils.formatDateTime(filters.dtEnd) : null,
      };

      const auditFilters = ReportUtils.filters({
          ...filters,
          dtStart: formattedFilters.dtStart,
          dtEnd: formattedFilters.dtEnd},
        filterLabels, true);

       const data = await passageLabelsXrayService.apply({...formattedFilters, filters: auditFilters});
      setReportData(data);

      const scale = window.visualViewport?.scale ?? 1;
      if (window.innerWidth <= 1440 || scale > 1) setCollapsed(true);

    } catch (error) {
      ReportUtils.alertErrorMessage("Erro ao gerar o relatório.");
      console.error("Erro ao gerar o relatório", error);
    } finally {
      setLoading(false);
    }
  }

  const clearSearch = () => {
    setFilters(initialFilters);
    setReportData(null);
  }

  useGlobalKey("Enter", apply);
  useGlobalKey("Escape", clearSearch);

  const toggleFilters = () => {
    if (!collapsed && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setFixedTop(rect.top);
    }

    setCollapsed(prev => !prev);
  }

  const printComponentRef = useRef(null);

  return (
      <div className={"flex"}>

        <Template isLoading={loading}>
          <Template.Header>
            <div className="flex justify-between w-full">
              <Template.Title>{title}</Template.Title>
              <HeaderButtons
                exportable={true}
                exportInSheets={true}
                printable={true}
                headerChange={true}
                printComponentRef={printComponentRef}
                reportData={reportData}
                data={reportData && (reportData?.totalLabels || reportData?.totalPassagesLabels)}
                headerSelected={headerSelected}
                setHeaderSelected={setHeaderSelected}
                setCollapsed={setCollapsed}
              />
            </div>
          </Template.Header>
          <Template.Body className={`${collapsed ? 'p-[0]' : ''}`}>
            <Menu buttonRef={buttonRef} toggleFilters={toggleFilters} fixedTop={fixedTop}
                  collapsed={collapsed} apply={apply} clearSearch={clearSearch}>

              <Filters setFilters={setFilters} filters={filters}/>
              <AutoDatetime setFilters={setFilters}/>

            </Menu>
          </Template.Body>
        </Template>

        <Card className={`w-full h-fit mr-2 ${!(reportData?.totalLabels || reportData?.totalPassagesLabels || 0 )? 'mt-[59px]' : 'mt-[61px]' } print:!mt-[-15px] transform ${!(reportData?.totalLabels || reportData?.totalPassagesLabels || 0) ? '!bg-[#f3f3f4] !border-none !-translate-y-[5px]' : ''} ${collapsed ? 'ml-2' : ''}`}>
          <Card.Body>
            <div className={`flex-1 ${!(reportData?.totalLabels || reportData?.totalPassagesLabels || 0) ? 'p-[0]' : 'px-[20px] py-[5px]'}`}>
              <NotAppliedContent reportData={reportData}/>
              <NoDataContent reportData={reportData} data={reportData?.totalLabels || reportData?.totalPassagesLabels || 0}/>
              <Content reportData={reportData} data={reportData?.totalLabels || reportData?.totalPassagesLabels || 0} entity={headerSelected} title={title} collapsed={collapsed} setLoading={setLoading} printComponentRef={printComponentRef}/>
            </div>
          </Card.Body>
        </Card>

      </div>
  );
};

export default PassageLabelsXRay;